import DEFAULT_PROP from '@/assets/json/field_types.json'
export default {
  computed: {
    propertiesFormReference () {
      return {
        title: this.isShowAttachment ? this.isCreate ? 'Create' : this.$t('message.hse.upload') : this.$t('message.hse.updateMetaData'),
        properties: this.formProps,
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.isShowAttachment ? this.isCreate ? 'Create' : this.$t('message.hse.upload') : this.$t('message.common.update'),
          click: this.isShowAttachment ? this.uploadDocumentHandler : this.updateDocumentMeta,
          loading: this.documentFormloading,
          is_show: true
        }, {
          name: 'close',
          color: 'error',
          click: this.closeDocumentDialogHandler,
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    },
    folderActions () {
      return [{
        tooltip: this.$t('message.hse.openNewTab'),
        icon: 'mdi-open-in-new',
        color: 'primary',
        click: (document) => this.navigateToOD(document)
      }, {
        tooltip: this.$t('message.hse.rename'),
        icon: 'mdi-border-color',
        color: 'success',
        click: (document) => this.renameFolderFormShow(document)
      }]
    },
    documentActions () {
      return [{
        tooltip: this.$t('message.hse.openNewTab'),
        icon: 'mdi-open-in-new',
        color: 'primary',
        click: (document) => this.navigateToOD(document)
      }, {
        tooltip: this.$t('message.hse.editMeta'),
        icon: 'mdi-border-color',
        color: 'success',
        click: (document) => this.editMetaInDocument(document)
      }, {
        tooltip: this.$t('message.common.download'),
        icon: 'mdi-cloud-download',
        color: 'accent',
        click: (document) => this.downloadHandler(document.id)
      }, {
        tooltip: this.$t('message.hse.versionHistory'),
        icon: 'mdi-history',
        color: 'purple',
        click: (document) => this.getVersionInfo(document.id)
      }, {
        tooltip: this.$t('message.common.delete'),
        icon: 'mdi-delete',
        color: 'error',
        click: (document) => this.deleteHandler(document.id)
      }]
    }
  },
  created () {
    // this.$store.dispatch('getHeaderFooterDocuments')
  },
  methods: {
    prepareFieldsForProperties () {
      let dynamicInputs = []
      this.dateFieldsForConversion = []
      for (let i = 0; i < this.dynamicFormFields.length; i++) {
        let field = this.dynamicFormFields[i]
        switch (field.type) {
          case DEFAULT_PROP.URL:
          case DEFAULT_PROP.TEXT:
          case DEFAULT_PROP.FILE:
          case DEFAULT_PROP.CURRENCY:
            dynamicInputs.push({ model: field.name, type: this.formType.TEXT, label: field.title, class: 'xs12' })
            break
          case DEFAULT_PROP.NUMBER:
          case DEFAULT_PROP.INTERGER:
            dynamicInputs.push({ model: field.name, type: this.formType.NUMBER, label: field.title, class: 'xs12' })
            break
          case DEFAULT_PROP.NOTE:
            dynamicInputs.push({ model: field.name, type: this.formType.TEXTAREA, label: field.title, class: 'xs12' })
            break
          case DEFAULT_PROP.BOOLEAN:
            dynamicInputs.push({ model: field.name, type: this.formType.CHECKBOX, label: field.title, class: 'xs12' })
            break
          case DEFAULT_PROP.CHOICE:
            dynamicInputs.push({ model: field.name, type: this.formType.AUTO_COMPLETE, items: field.choices, label: field.title, class: 'xs12' })
            break
          case DEFAULT_PROP.MULTICHOICE:
            dynamicInputs.push({ model: field.name, type: this.formType.AUTO_COMPLETE, items: field.choices, multiple: true, label: field.title, class: 'xs12' })
            break
          case DEFAULT_PROP.USER:
            dynamicInputs.push({ model: field.name, type: this.formType.AUTO_COMPLETE, items: field.users, select_value: 'id', select_text: 'name', label: field.title, class: 'xs12' })
            break
          case DEFAULT_PROP.DATETIME:
            this.dateFieldsForConversion.push(field.name)
            dynamicInputs.push({ model: field.name, type: this.formType.DATEPICKER, menu: `${field.name}_menu`, picker: `${field.name}_picker`, label: field.title, class: 'xs12', color: 'primary lighten-1' })
            this.$watch(`propertyModel.properties.${field.name}_picker`, (val) => {
              if (val) {
                this.propertyModel.properties[field.name] = this.$format.formatDate(val, 'YYYY-MM-DD', 'DD.MM.YYYY')
              }
            })
            break
          default:
            break
        }
      }
      this.formProps = dynamicInputs
    },
    documentDialog (type) {
      if (type === 'create') this.isCreate = true
      this.isShowAttachment = true
      this.uploadDocumentDialog = true
      let attachmentRefIndex = this.formProps.findIndex(x => x.model === 'files')
      if (attachmentRefIndex !== -1) this.formProps.splice(attachmentRefIndex, 1)
      let attachmentRefTempIndex = this.formProps.findIndex(x => x.model === 'template_id')
      if (attachmentRefTempIndex !== -1) this.formProps.splice(attachmentRefTempIndex, 1)
      this.propertyModel = { properties: {} }
      if (this.isShowAttachment) {
        if (this.isCreate) {
          this.formProps.push({
            model: 'template_id',
            type: this.formType.AUTO_COMPLETE,
            is_show: this.isShowAttachment && this.isCreate,
            items: this.listOfTemplates,
            select_text: 'name',
            select_value: '_id',
            rules: this.$_multiSelectValidation,
            label: 'Select Template',
            class: 'lg12'
          })
        } else {
          this.formProps.push({
            model: 'files',
            type: this.formType.FILES,
            is_show: this.isShowAttachment,
            rules: this.$_multiSelectValidation,
            label: this.$t('message.hse.files'),
            class: 'lg12'
          })
        }
      }
    },
    renameFolderFormShow (item) {
      this.isCreateFolder = false
      this.renameModel.id = item.id
      this.renameModel.name = item.name
      this.folderRenameDialog = true
    },
    editMetaInDocument (item) {
      this.isShowAttachment = false
      this.uploadDocumentDialog = true
      this.propertyModel = this.$format.cloneVariable(item)
      let properties = this.propertyModel.properties
      let formModel = {}
      for (let i = 0; i < properties.length; i++) {
        this.dateFieldsForConversion.forEach(element => {
          if (element === properties[i].name && properties[i].value) {
            properties[i].value = this.$format.formatDate(properties[i].value, 'DD.MM.YYYYTHH:mm:ss', 'DD.MM.YYYY')
          }
        })
        if (properties[i].value && properties[i].value.lookupid) formModel[properties[i].name] = properties[i].value.lookupid
        else formModel[properties[i].name] = properties[i].value
      }
      this.propertyModel.properties = formModel
      let attachmentRefIndex = this.formProps.findIndex(x => x.model === 'files')
      if (attachmentRefIndex >= 0) this.formProps.splice(attachmentRefIndex, 1)
      let headerRefIndex = this.formProps.findIndex(x => x.model === 'header_footer_id')
      if (headerRefIndex >= 0) this.formProps.splice(headerRefIndex, 1)
    },
    closeDocumentDialogHandler () {
      this.uploadDocumentDialog = false
      this.isCreate = false
      this.$refs.documentReference.$refs.validateForm.reset()
    },
    navigateToOD (document) {
      if (!document) return
      window.open(document.is_document ? document.weburl : document.path, '_blank')
    },
    navigateHandler (weburl) {
      window.open(weburl, '_blank')
    },
    downloadHandler (id) {
      this.loading = true
      this.$api.execute('get', `sharepoint/download/${id}`)
        .then((response) => {
          this.loading = false
          window.open(`${process.env.VUE_APP_URL}files/download?fileName=${response.data}`, '_blank')
        })
    },
    getVersionInfo (id) {
      this.loading = true
      this.$api.execute('get', `sharepoint/get_document_versions/${id}`).then(response => {
        this.versionHistory = []
        this.versionHistory = response.data
        this.versionHistoryDialog = true
      }).finally(() => {
        this.loading = false
      })
    },
    deleteHandler (id) {
      let payload = { url: `sharepoint/delete/${id}`, module: 'sharepoint', isSingle: true }
      this.$store.commit('showDeleteDialog', payload)
    }
  }
}
